
    const data = {"name":"src/core/icons/calendar-blank","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1V1\"/>","originalColors":[],"stopColors":[]}}

            export default data
            